<template>
  <el-container class="baohus" >
    <el-row :style="{'width': screenWidth+'px','height': screenHeight+'px','background-color': '#fff'}">
      <h4 style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">金刚经悟透一生受用的8个字</h4>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       我们都知道《金刚经》在我国是非常流行的一部经典，禅宗六祖大师就是通过《金刚经》开悟，也就是大彻大悟的。佛在讲《金刚经》时，当机者是须菩提，而须菩提在佛的十大弟子中被称为"解空第一"。
       《金刚经》全名《金刚般若波罗蜜经》，是大乘般若经典。金刚经中的一些名句，“凡所有相皆是虚妄，若见诸相非相，即见如来”，还有最著名的一句“一切有为法，如梦幻泡影，如露亦如电，应作如是观”。
       看上去《金刚经》是在讲空，其实是真空妙有。这里也许大家有所误解，金刚经是讲了空没错，但它并没有说一切皆空，也没有让我们去执着于空。
       
      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
      一个人，一旦着了空，就会认为，世间一切，皆是空的，既然都是空的，就不会在乎因果了，做事情也就没了原则，而且这样的人，比较消极，认为一切都是空的，还努力干嘛？
      努力也是空的，工作生活也都是空的，如果这样想，这个人连做人都做不好，也无法理解佛法真的要告诉我们的。《金刚经》是讲般若智慧的，令发菩提心菩萨，发心度尽一切众生，令其皆证无余涅槃，而不见有一众生得灭度者。
      不住色声香味触法而行布施。布施为六度万行之首，举布施则持戒忍辱精进禅定智慧，乃至万行，皆当不住色声香味触法而修。须菩提在大觉者佛陀的教导下，明白宇宙人生的事物是因缘和合的，一切是因缘所成，一切也由因缘所灭。
      
      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
      因缘，就是「空」的最好注解。“世尊！若复有人得闻是经，信心清净，则生实相，当知是人成就第一稀有功德。世尊！是实相者，即是非相，是故如来说名实相。
      世尊！我今得闻如是经典，信解受持，不足为难。若当来世，后五百岁，其有众生得闻是经，信解受持，是人即为第一稀有！何以故？此人无我相、无人相、无众生相、无寿者相。所以者何？我相即是非相，人相、众生相、寿者相即是非相。何以故？离一切诸相，即名诸佛。
      ”《金刚经》上教我们的“离相”，是离开心中的一切妄相，不要把相放在心上。因为我们的心一想，那个相就显现出来了。内心若是有执着，分别心也就产生了。所以说，“离相”也就是离开我们的妄想、分别和执着，这样真心才会得以显现出来。
     
      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       什么是真心？即道心，清净心、平等心、菩提心，具有无量智慧和无量福德。所以我们修行也是如此，通过自身的这个假相色身来借假修真。我们不可能离开一切相，但是要离开一切颠倒妄想。
       就如《般若波罗蜜多心经》里讲的那样：心无挂碍，无挂碍故，无有恐怖，远离颠倒梦想，究竟涅槃。
       当年，释迦牟是佛证悟成佛时，也曾感慨道，“奇哉，奇哉，一切众生，皆有如来智慧德相，只因妄想执著，不能证得。若离妄想，则无师智、自然智，一切显现。金刚经》中有很重要的8个字，就是“应无所住而生其心”。
       
      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       而且当年六祖慧能大师也是听到这句话而开悟的，这句话的原文是“是故，须菩提，诸菩萨摩诃萨，应如是生清净心，不应住色生心，不应住声、香、味、触、法生心，应无所住而生其心。”
       意思是：佛说：“所以，须菩提，发了菩提心的大乘菩萨应如是生清净心，不要被世间的贪嗔痴所转，不要执著色、声、香、味、触、法，应无所执著而生清净心。”“无所住”的是什么？原文中说了，无所住就是要断除这六尘（色、声、香、味、触、法），“生”的又是什么心？
       然后要生起来的是清净心。无所住就是不要在这六尘上面有所执著。这六尘所对应的是六根（眼、耳、鼻、舌、身、意），要断除六根的执著这就不容易了。“无所住”之后要“生其心”了。这就是告诉了一个方向，断除了这些过患之后，应该走向何方？
       
      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       生的是清净心。前面要断除各种贪、嗔、痴的心，这又要生清净心。到底是要断了还是要生呢？好吧。“无所住”是断除的实有的执著，心的本质是空性，不执著了才会显现空性。而清净之心就是空性中所显现的智慧。
       “应无所住”是本来清净，“而生其心”是任运自成。空也是“清净”，有也是“清净”，这才是“真清净”。所以，在读《金刚经》，每每读到“应无所住而生其心”，都会觉得很有道理。所以悟透这8个字，一生受用。
      </p>
     
    </el-row>
  </el-container>

</template>

<script>
  export default {
    data() {
      return {

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,

      };
    },
  }
</script>

<style>
  h2{
  		text-align: center;
  	}
  	p{
  		margin:0 0 0 25px;
  		line-height: 25px;
  	}
  	h4{
  		margin:5 0 5 0;
  	}


</style>



// WEBPACK FOOTER //
// src/components/main/fo/1.vue